import axios from 'axios';
import { authHeader2, authHeaderFormData } from '@/helper/authHeader';

const API_URL = process.env.API_URL;

const segmentEndpoint = '/mission';

export async function getChannelList(filter) {
  const url = `${API_URL}/admin${segmentEndpoint}/channel`;
  return axios({ url,
    method: 'get',
    params: filter,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addChannel(data) {
  const url = `${API_URL}/admin${segmentEndpoint}/create-channel`;
  return axios({
    url,
    method: 'post',
    data,
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function editChannel(data) {
  const url = `${API_URL}/admin${segmentEndpoint}/update-channel`;
  return axios({
    url,
    method: 'post',
    data,
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function detailChannel(data) {
  const url = `${API_URL}/admin${segmentEndpoint}/detail-channel/${data.id}`;
  return axios({
    url,
    method: 'get',
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteChannel(data) {
  const url = `${API_URL}/admin${segmentEndpoint}/delete-channel?id=${data.id}`;
  return axios({
    url,
    method: 'DELETE',
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getVideosList(data, filter) {
  const url = `${API_URL}/admin${segmentEndpoint}/channel/${data.id}/video`;
  return axios({ url,
    method: 'get',
    params: filter,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addVideos(data,onUploadProgress) {
  const url = `${API_URL}/admin${segmentEndpoint}/create-video`;
  return axios({
    url,
    method: 'post',
    data,
    headers: authHeaderFormData(),
    onUploadProgress,
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function editVideos(data, onUploadProgress) {
  const url = `${API_URL}/admin${segmentEndpoint}/update-video`;
  return axios({
    url,
    method: 'post',
    data,
    headers: authHeaderFormData(),
    onUploadProgress,
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function detailVideos(data) {
  const url = `${API_URL}/admin${segmentEndpoint}/detail-video/${data.id}`;
  return axios({
    url,
    method: 'get',
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteVideos(data) {
  const url = `${API_URL}/admin${segmentEndpoint}/delete-video?id=${data.id}`;
  return axios({
    url,
    method: 'DELETE',
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function publishVideos(data) {
  const url = `${API_URL}/admin${segmentEndpoint}/update-published`;
  return axios({
    url,
    method: 'post',
    data,
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getCategoryList() {
  const url = `${API_URL}/admin/master/video-category`;
  return axios({ url,
    method: 'get',
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getSearchVideos(data) {
  const url = `${API_URL}/admin${segmentEndpoint}/video`;
  return axios({ url,
    method: 'get',
    params: data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getRecommendedVideos() {
  const url = `${API_URL}/admin${segmentEndpoint}/recommended-video`;
  return axios({ url,
    method: 'get',
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function setRecommendedVideos(data) {
  const url = `${API_URL}/admin${segmentEndpoint}/recommended-video`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getPlaylists(data) {
  const url = `${API_URL}/admin/channel/playlist/list/${data.id}`;
  return axios({ url,
    method: 'get',
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function searchVideosPlaylists(id, filter) {
  const url = `${API_URL}/admin/channel/playlist/search-video/${id}`;
  return axios({ url,
    method: 'get',
    params: filter,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addPlaylists(data) {
  const url = `${API_URL}/admin/channel/playlist/create`;
  return axios({
    url,
    method: 'post',
    data,
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function editPlaylists(data) {
  const url = `${API_URL}/admin/channel/playlist/update`;
  return axios({
    url,
    method: 'post',
    data,
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function detailPlaylists(id) {
  const url = `${API_URL}/admin/channel/playlist/detail/${id}`;
  return axios({
    url,
    method: 'get',
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function deletePlaylists(data) {
  const url = `${API_URL}/admin/channel/playlist/delete`;
  return axios({
    url,
    method: 'post',
    data,
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function reOrderPlaylists(data) {
  const url = `${API_URL}/admin/channel/playlist/re-order`;
  return axios({
    url,
    method: 'post',
    data,
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function setStatusPlaylists(data) {
  const url = `${API_URL}/admin/channel/playlist/set-publish`;
  return axios({
    url,
    method: 'post',
    data,
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}




// WEBPACK FOOTER //
// ./src/services/missionsvideos.js